import * as React from 'react';

import TextFeedbackRow from 'pages/open-course/peerReview/components/TextFeedbackRow';
import TextFeedbackTable from 'pages/open-course/peerReview/components/TextFeedbackTable';
import type Review from 'pages/open-course/peerReview/reviewTypes/structured/models/review';
import type ReviewSchemaPart from 'pages/open-course/peerReview/reviewTypes/structured/partTypes/multiLineInput/models/schema';

import TranslatedContentWithButton from 'bundles/peer/components/translation/TranslatedContentWithButton';
import Content from 'bundles/phoenix/components/Content';

import 'css!./__styles__/MultiLineInputDisplayPart';

type Props = {
  reviewSchemaPart: typeof ReviewSchemaPart;
  reviews: (typeof Review)[];
  isAIGraded?: boolean;
  submissionId?: string;
  enableTranslation?: boolean;
  courseId?: string;
};

type ReviewRowProps = {
  reviewSchemaPart: typeof ReviewSchemaPart;
  review: typeof Review;
  isAIGraded?: boolean;
  enableTranslation?: boolean;
  courseId?: string;
};

const ReviewRow = ({ reviewSchemaPart, review, isAIGraded, enableTranslation, courseId }: ReviewRowProps) => {
  const partId = reviewSchemaPart.get('id');
  const reviewPart = review.get('parts').get(partId);

  const reviewInput = reviewPart.get('input');
  const reviewMaxScore = reviewSchemaPart.get('points');
  const reviewScore = reviewMaxScore && (reviewPart.get('score') || '-');
  const creatorScore = (reviewMaxScore && `${reviewScore}/${reviewMaxScore}`) || null;
  const reviewCreator = review.get('creator');

  if (reviewInput || creatorScore) {
    return (
      <TextFeedbackRow
        creatorFullName={reviewCreator.get('fullName')}
        creatorPhotoUrl={reviewCreator.get('photoUrl')}
        isAnonymous={reviewCreator.get('isAnonymous')}
        creatorScore={creatorScore}
        isAIGraded={isAIGraded}
        reviewId={review?.id}
        reviewPartId={partId}
      >
        {reviewInput &&
          (enableTranslation ? (
            <TranslatedContentWithButton
              className="review-text"
              content={reviewInput}
              courseId={courseId}
              eventingSectionName="peer_feedback"
            />
          ) : (
            <Content className="review-text" content={reviewInput} />
          ))}
      </TextFeedbackRow>
    );
  }

  return null;
};

class MultiLineInputDisplayPart extends React.Component<Props> {
  render() {
    const { reviewSchemaPart, reviews, isAIGraded, enableTranslation, courseId } = this.props;

    return (
      <div className="rc-MultiLineInputDisplayPart">
        <Content assumeStringIsHtml={false} content={reviewSchemaPart.get('prompt')} />
        <TextFeedbackTable>
          {reviews.map((review) => (
            <ReviewRow
              key={review.get('id')}
              reviewSchemaPart={reviewSchemaPart}
              review={review}
              isAIGraded={isAIGraded}
              enableTranslation={enableTranslation}
              courseId={courseId}
            />
          ))}
        </TextFeedbackTable>
      </div>
    );
  }
}

export default MultiLineInputDisplayPart;
